import React, { useState, useEffect, useRef, useContext } from "react";

import * as Yup from "yup";
import { Formik, Form, Field } from "formik";
import { toast } from "react-toastify";
import { head } from "lodash";

import { makeStyles } from "@material-ui/core/styles";
import { green } from "@material-ui/core/colors";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CircularProgress from "@material-ui/core/CircularProgress";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import Chip from '@material-ui/core/Chip';
import Checkbox from '@material-ui/core/Checkbox';
import ListItemText from '@material-ui/core/ListItemText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import { isNil } from "lodash";
import { i18n } from "../../translate/i18n";
import moment from "moment";

import api from "../../services/api";
import toastError from "../../errors/toastError";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@material-ui/core";
import { AuthContext } from "../../context/Auth/AuthContext";
import ConfirmationModal from "../ConfirmationModal";
import UserStatusIcon from "../UserModal/statusIcon";
import Autocomplete, { createFilterOptions } from "@material-ui/lab/Autocomplete";
import useQueues from "../../hooks/useQueues";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },

  textField: {
    marginRight: theme.spacing(1),
    flex: 1,
  },

  extraAttr: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },

  btnWrapper: {
    position: "relative",
  },

  buttonProgress: {
    color: green[500],
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));

// ✅ COMPONENTE TABPANEL PARA AS ABAS
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`campaign-tabpanel-${index}`}
      aria-labelledby={`campaign-tab-${index}`}
      style={{ padding: 20 }} // ✅ ALTURA AUTOMÁTICA PARA AMBAS AS ABAS
      {...other}
    >
      {value === index && (
        <Box p={3}>
          {children}
        </Box>
      )}
    </div>
  );
}

// ✅ PROPRIEDADES DE ACESSIBILIDADE PARA TABS
function a11yProps(index) {
  return {
    id: `campaign-tab-${index}`,
    'aria-controls': `campaign-tabpanel-${index}`,
  };
}

const CampaignSchema = Yup.object().shape({
  name: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("Required"),
});

const CampaignModal = ({
  open,
  onClose,
  campaignId,
  initialValues,
  onSave,
  resetPagination,
}) => {
  const classes = useStyles();
  const isMounted = useRef(true);
  const { user, socket } = useContext(AuthContext);
  const { companyId } = user;

  const initialState = {
    name: "",
    message1: "",
    message2: "",
    message3: "",
    message4: "",
    message5: "",
    confirmationMessage1: "",
    confirmationMessage2: "",
    confirmationMessage3: "",
    confirmationMessage4: "",
    confirmationMessage5: "",
    status: "INATIVA", // INATIVA, PROGRAMADA, EM_ANDAMENTO, CANCELADA, FINALIZADA,
    confirmation: false,
    scheduledAt: "",
    //whatsappId: "",
    contactListId: "",
    tagListId: "Nenhuma",
    companyId,
    statusTicket: "closed",
    openTicket: "disabled",
    dailyLimit: 250, // ✅ Limite padrão 250 mensagens/dia
    contactSource: "contactList", // ✅ Origem padrão: lista manual
    sourceWhatsappId: "" // ✅ WhatsApp para grupos
  };

  const [campaign, setCampaign] = useState(initialState);
  const [whatsapps, setWhatsapps] = useState([]);
  const [selectedWhatsapps, setSelectedWhatsapps] = useState([]);
  const [whatsappId, setWhatsappId] = useState(false);

  const [contactLists, setContactLists] = useState([]);
  const [tagLists, setTagLists] = useState([]);
  const [messageTab, setMessageTab] = useState(0);
  
  // ✅ NOVOS ESTADOS: Anexos individuais para cada mensagem
  const [attachments, setAttachments] = useState({
    message1: null,
    message2: null,
    message3: null,
    message4: null,
    message5: null
  });
  
  const [campaignEditable, setCampaignEditable] = useState(true);
  
  // ✅ NOVOS REFS: Um ref para cada input de arquivo
  const attachmentFileRefs = useRef({
    message1: null,
    message2: null,
    message3: null,
    message4: null,
    message5: null
  });

  // ✅ NOVOS ESTADOS PARA GRUPOS E LIMITE DIÁRIO
  const [contactSource, setContactSource] = useState("contactList");
  const [isSubmitting, setIsSubmitting] = useState(false); // ✅ Trava para evitar dupla submissão
  const [sourceWhatsappId, setSourceWhatsappId] = useState("");
  const [dailyLimit, setDailyLimit] = useState(250); // ✅ Valor padrão 250
  const [availableGroups, setAvailableGroups] = useState([]); // ✅ LISTA DE GRUPOS DISPONÍVEIS
  const [selectedGroups, setSelectedGroups] = useState([]); // ✅ GRUPOS SELECIONADOS
  const [activeTab, setActiveTab] = useState(0); // ✅ CONTROLE DE TABS
  // ✅ VARIÁVEIS DE TEXTO POR CAMPANHA (ALEATÓRIAS)
  const [textVariables, setTextVariables] = useState({}); // { saudacao: ["Olá", "Oi"] }
  const [varKey, setVarKey] = useState("");
  const [varOption, setVarOption] = useState("");
  // ✅ VARIÁVEIS DE TEXTO DA EMPRESA (somente leitura aqui)
  const [companyTextVariables, setCompanyTextVariables] = useState({});

  // ✅ JANELA DE ENVIO POR CAMPANHA (padrão: sáb/dom desativados e 07:00–20:00)
  const [sendWindow, setSendWindow] = useState({ sabado: false, domingo: false, startHour: "07:00", endHour: "20:00" });
  // Guardas globais fixas de horário
  const GLOBAL_START = "07:00";
  const GLOBAL_END = "20:00";

  // Helpers para clamp de horário HH:mm
  const clampTime = (hhmm) => {
    if (!hhmm || typeof hhmm !== 'string') return hhmm;
    const toMin = (s) => {
      const [h, m] = s.split(":").map((x) => parseInt(x, 10));
      return (isNaN(h) || isNaN(m)) ? null : h * 60 + m;
    };
    const toStr = (mins) => `${String(Math.floor(mins / 60)).padStart(2,'0')}:${String(mins % 60).padStart(2,'0')}`;
    const v = toMin(hhmm);
    const min = toMin(GLOBAL_START);
    const max = toMin(GLOBAL_END);
    if (v == null || min == null || max == null) return hhmm;
    const clamped = Math.min(Math.max(v, min), max);
    return toStr(clamped);
  };

  // Normaliza o datetime-local para respeitar a guarda global (07-20) e não ser passado
  const normalizeScheduledAt = (val) => {
    if (!val) return val;
    // val formato "YYYY-MM-DDTHH:mm"
    const dt = moment(val);
    if (!dt.isValid()) return val;
    let result = dt.clone();
    // Se no passado, empurra para agora + 2 minutos (clamp de segurança)
    const now = moment();
    if (result.isBefore(now)) {
      result = now.add(2, 'minutes');
    }
    // Aplica guarda de horário 07-20
    const timePart = result.format('HH:mm');
    const clamped = clampTime(timePart);
    if (clamped !== timePart) {
      const [hh, mm] = clamped.split(':').map(Number);
      result.hours(hh).minutes(mm);
      // Se passou das 20:00 por clamp e ainda ficou no passado, joga para o próximo dia às 07:00
      if (result.isBefore(now)) {
        const [gH, gM] = GLOBAL_START.split(':').map(Number);
        result = now.clone().add(1, 'day').startOf('day').hours(gH).minutes(gM);
      }
    }
    return result.format('YYYY-MM-DDTHH:mm');
  };



  const [options, setOptions] = useState([]);
  const [queues, setQueues] = useState([]);
  const [allQueues, setAllQueues] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchParam, setSearchParam] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  
  // ✅ ESTADOS PARA DIALOG DE AVISO
  const [showWarningDialog, setShowWarningDialog] = useState(false);
  const [acceptedRisks, setAcceptedRisks] = useState(false);
  const [pendingSubmitValues, setPendingSubmitValues] = useState(null);
  const [selectedQueue, setSelectedQueue] = useState(null);
  const { findAll: findAllQueues } = useQueues();

  useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  useEffect(() => {
    if (isMounted.current) {
      const loadQueues = async () => {
        const list = await findAllQueues();
        setAllQueues(list);
        setQueues(list);

      };
      loadQueues();
      // Carregar variáveis da empresa sempre que o modal abrir
      if (open) {
        loadCompanyTextVariables();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (searchParam.length < 3) {
      setLoading(false);
      setSelectedQueue("");
      return;
    }
    const delayDebounceFn = setTimeout(() => {
      setLoading(true);
      const fetchUsers = async () => {
        try {
          const { data } = await api.get("/users/");
          setOptions(data.users);
          setLoading(false);
        } catch (err) {
          setLoading(false);
          toastError(err);
        }
      };

      fetchUsers();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam]);

  useEffect(() => {
    if (isMounted.current) {
      if (initialValues) {
        setCampaign((prevState) => {
          return { ...prevState, ...initialValues };
        });
      }

      api
        .get(`/contact-lists/list`, { params: { companyId } })
        .then(({ data }) => setContactLists(data));

      api
        .get(`/whatsapp`, { params: { companyId, session: 0 } })
        .then(({ data }) => {
          // Mapear os dados recebidos da API para adicionar a propriedade 'selected'
          const mappedWhatsapps = data.map((whatsapp) => ({
            ...whatsapp,
            selected: false,
          }));

          setWhatsapps(mappedWhatsapps);
        });

      api.get(`/tags/list`, { params: { companyId, kanban: 0 } })
        .then(({ data }) => {
          const fetchedTags = data;
          // Perform any necessary data transformation here
          const formattedTagLists = fetchedTags
            .filter(tag => tag.contacts.length > 0)  // Filtra as tags com contacts.length > 0
            .map((tag) => ({
              id: tag.id,
              name: `${tag.name} (${tag.contacts.length})`,
            }));

          setTagLists(formattedTagLists);
        })
        .catch((error) => {
          console.error("Error retrieving tags:", error);
        });

  if (!campaignId) return;

  api.get(`/campaigns/${campaignId}`).then(({ data }) => {

        if (data?.user)
          setSelectedUser(data.user);

        if (data?.queue)
          setSelectedQueue(data.queue.id)

        if (data?.whatsappId) {
          // const selectedWhatsapps = data.whatsappId.split(",");
          setWhatsappId(data.whatsappId);
        }
        setCampaign((prev) => {
          let prevCampaignData = Object.assign({}, prev);

          Object.entries(data).forEach(([key, value]) => {
            if (key === "scheduledAt" && value !== "" && value !== null) {
              prevCampaignData[key] = moment(value).format("YYYY-MM-DDTHH:mm");
            } else {
              prevCampaignData[key] = value === null ? "" : value;
            }
          });

          return prevCampaignData;
        });

        // Carregar configurações específicas desta campanha
        loadCampaignTextVariables(campaignId);
        loadCampaignSendWindow(campaignId);
  loadCompanyTextVariables();
      });
    }
  }, [campaignId, open, initialValues, companyId]);



  useEffect(() => {
    const now = moment();
    const scheduledAt = moment(campaign.scheduledAt);
    const moreThenAnHour =
      !Number.isNaN(scheduledAt.diff(now)) && scheduledAt.diff(now, "hour") > 1;
    const isEditable =
      campaign.status === "INATIVA" ||
      (campaign.status === "PROGRAMADA" && moreThenAnHour);

    setCampaignEditable(isEditable);
  }, [campaign.status, campaign.scheduledAt]);

  // ✅ BUSCAR GRUPOS QUANDO NECESSÁRIO
  useEffect(() => {
    if (contactSource === 'specificGroups') {
      fetchAvailableGroups();
    }
  }, [contactSource]);

  // ✅ CARREGAR VARIÁVEIS DA CAMPANHA (SE EDIÇÃO)
  const loadCampaignTextVariables = async (id) => {
    try {
      const { data } = await api.get("/campaign-settings");
      if (Array.isArray(data)) {
        const item = data.find((s) => s.key === `textVariables:c:${id}`);
        if (item && item.value) {
          try {
            const parsed = typeof item.value === "string" ? JSON.parse(item.value) : item.value;
            if (parsed && typeof parsed === "object") {
              setTextVariables(parsed);
            }
          } catch (e) {
            console.error("Erro ao parsear textVariables da campanha:", e);
          }
        }
      }
    } catch (err) {
      console.error("Erro ao carregar campaign-settings:", err);
    }
  };

  // ✅ CARREGAR VARIÁVEIS DA EMPRESA (somente leitura)
  const loadCompanyTextVariables = async () => {
    try {
      const { data } = await api.get("/campaign-settings");
      if (Array.isArray(data)) {
        const item = data.find((s) => s.key === "textVariables");
        if (item && item.value) {
          try {
            const parsed = typeof item.value === "string" ? JSON.parse(item.value) : item.value;
            if (parsed && typeof parsed === "object") {
              setCompanyTextVariables(parsed);
            }
          } catch (e) {
            console.error("Erro ao parsear textVariables da empresa:", e);
          }
        } else {
          setCompanyTextVariables({});
        }
      }
    } catch (err) {
      console.error("Erro ao carregar textVariables (empresa):", err);
    }
  };

  // ✅ CARREGAR JANELA DA CAMPANHA (SE EDIÇÃO)
  const loadCampaignSendWindow = async (id) => {
    try {
      const { data } = await api.get("/campaign-settings");
      if (Array.isArray(data)) {
        const item = data.find((s) => s.key === `sendWindow:c:${id}`);
        if (item && item.value) {
          try {
            const parsed = typeof item.value === "string" ? JSON.parse(item.value) : item.value;
            if (parsed && typeof parsed === "object") {
              setSendWindow({
                sabado: parsed.sabado === true || parsed.sabado === "true",
                domingo: parsed.domingo === true || parsed.domingo === "true",
                startHour: parsed.startHour || GLOBAL_START,
                endHour: parsed.endHour || GLOBAL_END
              });
            }
          } catch (e) {
            console.error("Erro ao parsear sendWindow da campanha:", e);
          }
        } else {
          // Sem configuração salva: usar defaults (finais de semana desativados e 07:00–20:00)
          setSendWindow({ sabado: false, domingo: false, startHour: GLOBAL_START, endHour: GLOBAL_END });
        }
      }
    } catch (err) {
      console.error("Erro ao carregar campaign-settings (sendWindow):", err);
    }
  };

  // ✅ HELPERS PARA GERENCIAR VARIÁVEIS/OPÇÕES
  const normalizedKey = (key) => (key || "").toString().trim().toLowerCase().replace(/[^a-z0-9_-]/g, "").slice(0, 30);
  const addVarOption = () => {
    const k = normalizedKey(varKey);
    const opt = (varOption || "").toString().trim();
    if (!k || !opt) return;
    setTextVariables((prev) => {
      const current = Array.isArray(prev[k]) ? prev[k] : [];
      if (current.length >= 20) return prev; // limite de 20 opções
      if (Object.keys(prev).length >= 10 && !prev[k]) return prev; // até 10 variáveis
      if (current.includes(opt)) return prev;
      return { ...prev, [k]: [...current, opt] };
    });
    setVarOption("");
    if (!varKey) setVarKey(k);
  };
  const removeVarOption = (k, opt) => {
    setTextVariables((prev) => {
      const current = Array.isArray(prev[k]) ? prev[k] : [];
      const next = current.filter((o) => o !== opt);
      const clone = { ...prev };
      if (next.length === 0) delete clone[k]; else clone[k] = next;
      return clone;
    });
  };
  const removeVariable = (k) => {
    setTextVariables((prev) => {
      const clone = { ...prev };
      delete clone[k];
      return clone;
    });
  };

  // ✅ INSERIR PLACEHOLDER NO CAMPO DE MENSAGEM ATIVO
  const insertPlaceholderIntoActiveMessage = (placeholder) => {
    const fieldKey = `message${messageTab + 1}`;
    const textarea = document.getElementById(fieldKey);
    // Atualiza via DOM (controlado pelo Formik) inserindo no fim se não houver caret
    if (textarea) {
      const start = textarea.selectionStart ?? textarea.value.length;
      const end = textarea.selectionEnd ?? textarea.value.length;
      const current = textarea.value || "";
      const next = current.slice(0, start) + placeholder + current.slice(end);
      // Simular input para Formik reagir
      const nativeInputValueSetter = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, 'value').set;
      nativeInputValueSetter.call(textarea, next);
      const ev = new Event('input', { bubbles: true });
      textarea.dispatchEvent(ev);
      textarea.focus();
      // posiciona o cursor após o placeholder
      const caret = start + placeholder.length;
      setTimeout(() => {
        textarea.setSelectionRange(caret, caret);
      }, 0);
    } else {
      toast.info("Selecione uma aba de mensagem para inserir.");
    }
  };

  // ✅ IMPORTAR VARIÁVEL DA EMPRESA PARA OVERRIDES DA CAMPANHA
  const importCompanyVariableToCampaign = (key) => {
    const options = Array.isArray(companyTextVariables[key]) ? companyTextVariables[key] : [];
    if (!options.length) return;
    setTextVariables((prev) => ({
      ...prev,
      [key]: Array.isArray(prev[key]) && prev[key].length ? prev[key] : [...options]
    }));
    toast.success(`Variável {${key}} importada para esta campanha.`);
  };

  const handleClose = () => {
    onClose();
    setCampaign(initialState);
    setTextVariables({});
  setCompanyTextVariables({});
    setVarKey("");
    setVarOption("");
    setSendWindow({ sabado: false, domingo: false, startHour: "07:00", endHour: "20:00" });
  };

  // ✅ FUNÇÃO PARA BUSCAR GRUPOS DISPONÍVEIS
  const fetchAvailableGroups = async (whatsappFilter = 'all') => {
    try {
      const { data } = await api.get(`/campaigns/available-groups?whatsappId=${whatsappFilter}`);
      setAvailableGroups(data.groups || []);
    } catch (error) {
      console.error('Error fetching groups:', error);
      toast.error('Erro ao buscar grupos disponíveis');
  }
  };

  // ✅ NOVAS FUNÇÕES: Anexos individuais por mensagem
  const handleIndividualAttachmentFile = (messageNumber, e) => {
    const file = head(e.target.files);
    if (file) {
      setAttachments(prev => ({
        ...prev,
        [`message${messageNumber}`]: file
      }));
    }
  };

  const removeIndividualAttachment = async (messageNumber) => {
    try {
      // Se é uma campanha existente, remove do servidor
      if (campaignId) {
        await api.delete(`/campaigns/${campaignId}/media-upload/${messageNumber}`);
        
        // Atualiza o estado da campanha removendo os campos de mídia correspondentes
        setCampaign(prev => ({
          ...prev,
          [`mediaPath${messageNumber}`]: null,
          [`mediaName${messageNumber}`]: null
        }));
      }

      // Remove do estado local
      setAttachments(prev => ({
        ...prev,
        [`message${messageNumber}`]: null
      }));

      // Limpa o input file correspondente
      if (attachmentFileRefs.current[`message${messageNumber}`]) {
        attachmentFileRefs.current[`message${messageNumber}`].value = null;
      }

      toast.success(`Anexo da mensagem ${messageNumber} removido com sucesso`);
    } catch (err) {
      toastError(err);
    }
  };

  const uploadIndividualMedia = async (messageNumber) => {
    const file = attachments[`message${messageNumber}`];
    if (!file) return;

    const formData = new FormData();
    formData.append("file", file);

    try {
      await api.post(`/campaigns/${campaignId}/media-upload/${messageNumber}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });

      // Atualiza o estado da campanha com os novos dados
      setCampaign(prev => ({
        ...prev,
        [`mediaPath${messageNumber}`]: file.name, // Temporário até recarregar
        [`mediaName${messageNumber}`]: file.name
      }));

      // Remove do estado local pois já foi salvo
      setAttachments(prev => ({
        ...prev,
        [`message${messageNumber}`]: null
      }));

      toast.success(`Anexo da mensagem ${messageNumber} enviado com sucesso`);
    } catch (err) {
      toastError(err);
    }
  };

  const handleSaveCampaign = async (values) => {
    // ✅ INTERCEPTAR SALVAMENTO PARA MOSTRAR AVISO
    setPendingSubmitValues(values);
    setShowWarningDialog(true);
  };

  const handleConfirmSave = async () => {
    if (!acceptedRisks) {
      toast.error("Você precisa aceitar os riscos para continuar");
      return;
    }

    if (isSubmitting) {
      console.log("Submissão já em andamento, ignorando...");
      return;
    }

    // VALIDAR JANELA DE ENVIO
    if (sendWindow?.startHour && sendWindow?.endHour && sendWindow.startHour > sendWindow.endHour) {
      toast.error("Horário inicial deve ser menor que o horário final");
      return;
    }

    setIsSubmitting(true); // ✅ Ativar trava

  try {
      const values = pendingSubmitValues;
      // Validação: scheduledAt não pode ser no passado e deve respeitar 07:00–20:00
      if (values?.scheduledAt) {
        const sched = moment(values.scheduledAt);
        if (!sched.isValid()) {
          toast.error("Agendamento inválido");
          setIsSubmitting(false);
          return;
        }
        const now = moment();
        if (sched.isBefore(now)) {
          toast.error("Agendamento não pode ser no passado");
          setIsSubmitting(false);
          return;
        }
        const timeStr = sched.format('HH:mm');
        const toMin = (s) => { const [h,m] = s.split(':').map(Number); return h*60+m; };
        if (toMin(timeStr) < toMin(GLOBAL_START) || toMin(timeStr) > toMin(GLOBAL_END)) {
          toast.error("Horário permitido: 07:00 às 20:00");
          setIsSubmitting(false);
          return;
        }
      }
      console.log('=== DEBUG VALUES ===');
      console.log('values.contactSource:', values.contactSource);
      console.log('contactSource state:', contactSource);
      console.log('====================');
      
      const dataValues = {
        // ✅ REMOVER ...values temporariamente para testar
        name: values.name,
        message1: values.message1,
        message2: values.message2,
        message3: values.message3,
        message4: values.message4,
        message5: values.message5,
        confirmationMessage1: values.confirmationMessage1,
        confirmationMessage2: values.confirmationMessage2,
        confirmationMessage3: values.confirmationMessage3,
        confirmationMessage4: values.confirmationMessage4,
        confirmationMessage5: values.confirmationMessage5,
        status: values.status,
        confirmation: values.confirmation,
        scheduledAt: values.scheduledAt,
        contactListId: values.contactListId,
        tagListId: values.tagListId,
        companyId: values.companyId,
        statusTicket: values.statusTicket,
        openTicket: values.openTicket,
        dailyLimit: values.dailyLimit,
        // ✅ FORÇAR os valores corretos do estado
        whatsappId: whatsappId || null,
        userId: selectedUser?.id || null,
        queueId: selectedQueue || null,
        contactSource: contactSource, // ✅ Usar direto do estado
        sourceWhatsappId: sourceWhatsappId || null,
  selectedGroupIds: selectedGroups || [], // ✅ IDs dos grupos selecionados
  dailyLimit: dailyLimit || 250,
  // ✅ ENVIAR VARIÁVEIS DA CAMPANHA
  textVariables: textVariables && Object.keys(textVariables).length ? textVariables : undefined,
  sendWindow: sendWindow,
      };

      console.log('=== DEBUG FRONTEND ===');
      console.log('contactSource state:', contactSource);
      console.log('selectedGroups:', selectedGroups);
      console.log('dataValues.contactSource:', dataValues.contactSource);
      console.log('======================');

      //console.log(values);
      //console.log(selectedWhatsapps);

      Object.entries(values).forEach(([key, value]) => {
        // ✅ NÃO sobrescrever campos que já configuramos corretamente
        if (key === "contactSource" || key === "selectedGroupIds" || key === "whatsappId" || key === "userId" || key === "queueId" || key === "sourceWhatsappId") {
          return; // Pular esses campos
        }
        
        if (key === "scheduledAt" && value !== "" && value !== null) {
          dataValues[key] = moment(value).format("YYYY-MM-DD HH:mm:ss");
        } else {
          dataValues[key] = value === "" ? null : value;
        }
      });

      console.log('=== ANTES DE ENVIAR PARA API ===');
      console.log('dataValues final:', JSON.stringify(dataValues, null, 2));
      console.log('================================');

      if (campaignId) {
        await api.put(`/campaigns/${campaignId}`, dataValues);

        // ✅ UPLOAD DOS ANEXOS INDIVIDUAIS
        for (let i = 1; i <= 5; i++) {
          const messageKey = `message${i}`;
          const attachmentFile = attachments[messageKey];
          
          if (attachmentFile) {
            const formData = new FormData();
            formData.append("file", attachmentFile);
            await api.post(`/campaigns/${campaignId}/media-upload/${i}`, formData);
          }
        }
        
        handleClose();
      } else {
        const { data } = await api.post("/campaigns", dataValues);

        // ✅ UPLOAD DOS ANEXOS INDIVIDUAIS PARA NOVA CAMPANHA
        for (let i = 1; i <= 5; i++) {
          const messageKey = `message${i}`;
          const attachmentFile = attachments[messageKey];
          
          if (attachmentFile) {
            const formData = new FormData();
            formData.append("file", attachmentFile);
            await api.post(`/campaigns/${data.id}/media-upload/${i}`, formData);
          }
        }
        
        if (onSave) {
          onSave(data);
        }
        handleClose();
      }
      toast.success(i18n.t("campaigns.toasts.success"));
      
      // ✅ FECHAR DIALOG DE AVISO
      setShowWarningDialog(false);
      setAcceptedRisks(false);
      setPendingSubmitValues(null);
      setIsSubmitting(false); // ✅ Liberar trava
    } catch (err) {
      console.log(err);
      toastError(err);
      setIsSubmitting(false); // ✅ Liberar trava mesmo em caso de erro
    }
  };

  const handleCancelWarning = () => {
    setShowWarningDialog(false);
    setAcceptedRisks(false);
    setPendingSubmitValues(null);
  };

  const renderMessageField = (identifier) => {
    // Extrai o número da mensagem (1-5) do identificador
    const messageNumber = identifier.replace('message', '');
    const messageKey = identifier;
    
    // Verifica se há anexo local ou salvo
    const hasLocalAttachment = attachments[messageKey];
    const hasSavedAttachment = campaign[`mediaPath${messageNumber}`];
    const currentAttachment = hasLocalAttachment || hasSavedAttachment;
    
    return (
      <div>
        <Field
          as={TextField}
          id={identifier}
          name={identifier}
          fullWidth
          rows={12}
          label={i18n.t(`campaigns.dialog.form.${identifier}`)}
          placeholder={i18n.t("campaigns.dialog.form.messagePlaceholder")}
          multiline={true}
          variant="outlined"
          // Dica movida para a seção "Variáveis desta campanha"
          disabled={!campaignEditable && campaign.status !== "CANCELADA"}
        />
        
        {/* ✅ CONTROLES DE ANEXO INDIVIDUAL */}
        <div style={{ marginTop: 8, display: 'flex', alignItems: 'center', gap: 8 }}>
          
          {/* Input oculto para seleção de arquivo */}
          <input
            type="file"
            accept=".doc,.docx,.pdf,.xls,.xlsx,.csv,.txt,.jpg,.jpeg,.png,.gif,.mp4,.mp3,.wav,.ogg"
            style={{ display: 'none' }}
            ref={(el) => {
              if (attachmentFileRefs.current) {
                attachmentFileRefs.current[messageKey] = el;
              }
            }}
            onChange={(e) => handleIndividualAttachmentFile(messageNumber, e)}
          />
          
          {/* Exibição do anexo atual */}
          {currentAttachment && (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: 8, backgroundColor: '#f5f5f5', borderRadius: 4, flex: 1 }}>
              <AttachFileIcon color="primary" />
              <span style={{ fontSize: '0.875rem' }}>
                {hasLocalAttachment ? hasLocalAttachment.name : campaign[`mediaName${messageNumber}`]}
              </span>
              
              {/* Botão de upload (para anexos locais) */}
              {hasLocalAttachment && campaignId && (
                <Button
                  size="small"
                  color="primary"
                  onClick={() => uploadIndividualMedia(messageNumber)}
                  disabled={!campaignEditable}
                >
                  Enviar
                </Button>
              )}
              
              {/* Botão de remoção */}
              <IconButton
                size="small"
                color="secondary"
                onClick={() => removeIndividualAttachment(messageNumber)}
                disabled={!campaignEditable}
              >
                <DeleteOutlineIcon />
              </IconButton>
            </div>
          )}
          
          {/* Botão para adicionar anexo (quando não há anexo) */}
          {!currentAttachment && campaignEditable && (
            <Button
              variant="outlined"
              size="small"
              startIcon={<AttachFileIcon />}
              onClick={() => {
                if (attachmentFileRefs.current[messageKey]) {
                  attachmentFileRefs.current[messageKey].click();
                }
              }}
            >
              Anexar arquivo
            </Button>
          )}
        </div>
      </div>
    );
  };

  const renderConfirmationMessageField = (identifier) => {
    return (
      <Field
        as={TextField}
        id={identifier}
        name={identifier}
        fullWidth
        rows={12}
        label={i18n.t(`campaigns.dialog.form.${identifier}`)}
        placeholder={i18n.t("campaigns.dialog.form.messagePlaceholder")}
        multiline={true}
        variant="outlined"
        disabled={!campaignEditable && campaign.status !== "CANCELADA"}
      />
    );
  };

  const cancelCampaign = async () => {
    try {
      await api.post(`/campaigns/${campaign.id}/cancel`);
      toast.success(i18n.t("campaigns.toasts.cancel"));
      setCampaign((prev) => ({ ...prev, status: "CANCELADA" }));
      resetPagination();
    } catch (err) {
      toast.error(err.message);
    }
  };

  const restartCampaign = async () => {
    try {
      await api.post(`/campaigns/${campaign.id}/restart`);
      toast.success(i18n.t("campaigns.toasts.restart"));
      setCampaign((prev) => ({ ...prev, status: "EM_ANDAMENTO" }));
      resetPagination();
    } catch (err) {
      toast.error(err.message);
    }
  };

  const filterOptions = createFilterOptions({
    trim: true,
  });

  return (
    <div className={classes.root}>
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        scroll="paper"
        disableAutoFocus
        PaperProps={{
          style: {
            maxHeight: '90vh',
            height: 'auto'
          }
        }}
      >
        <DialogTitle id="form-dialog-title">
          {campaignEditable ? (
            <>
              {campaignId
                ? `${i18n.t("campaigns.dialog.update")}`
                : `${i18n.t("campaigns.dialog.new")}`}
            </>
          ) : (
            <>{`${i18n.t("campaigns.dialog.readonly")}`}</>
          )}
        </DialogTitle>
        <Formik
          initialValues={campaign}
          enableReinitialize={true}
          validationSchema={CampaignSchema}
          onSubmit={(values, actions) => {
            setTimeout(() => {
              handleSaveCampaign(values);
              actions.setSubmitting(false);
            }, 400);
          }}
        >
          {({ values, errors, touched, isSubmitting, setFieldValue }) => (
            <Form>
              <DialogContent dividers style={{ overflow: 'auto' }}>
                {/* ✅ SISTEMA DE TABS */}
                <Tabs 
                  value={activeTab} 
                  onChange={(event, newValue) => setActiveTab(newValue)}
                  indicatorColor="primary"
                  textColor="primary"
                  centered
                >
                  <Tab label="Configurações" {...a11yProps(0)} />
                  <Tab label="Mensagens" {...a11yProps(1)} />
                </Tabs>

                {/* ✅ TAB 1: CONFIGURAÇÕES */}
                <TabPanel value={activeTab} index={0}>
                <Grid spacing={2} container>
                  
                  {/* ================================ */}
                  {/* PARTE 1: IDENTIFICAÇÃO */}
                  {/* ================================ */}
                  <Grid xs={12} item>
                    <Typography variant="h6" color="primary" style={{ marginBottom: 16, fontWeight: 'bold' }}>
                      📝 Identificação da Campanha
                    </Typography>
                  </Grid>
                  
                  <Grid xs={12} md={6} item>
                    <Field
                      as={TextField}
                      label={i18n.t("campaigns.dialog.form.name")}
                      name="name"
                      error={touched.name && Boolean(errors.name)}
                      helperText={touched.name && errors.name}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.textField}
                      disabled={!campaignEditable}
                    />
                  </Grid>

                  <Grid xs={12} md={6} item>
                    <Field
                      as={TextField}
                      label={i18n.t("campaigns.dialog.form.scheduledAt")}
                      name="scheduledAt"
                      error={touched.scheduledAt && Boolean(errors.scheduledAt)}
                      helperText={(touched.scheduledAt && errors.scheduledAt) || `Horário permitido: ${GLOBAL_START} às ${GLOBAL_END}. Valores fora serão ajustados.`}
                      variant="outlined"
                      margin="dense"
                      type="datetime-local"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ min: moment().format('YYYY-MM-DDT07:00'), max: moment().add(1, 'year').format('YYYY-MM-DDT20:00') }}
                      fullWidth
                      className={classes.textField}
                      disabled={!campaignEditable}
                      onChange={(e) => {
                        const val = e.target.value;
                        const normalized = normalizeScheduledAt(val);
                        setFieldValue('scheduledAt', normalized);
                      }}
                      onBlur={(e) => {
                        const val = e.target.value;
                        const before = val;
                        const normalized = normalizeScheduledAt(val);
                        setFieldValue('scheduledAt', normalized);
                        if (before && normalized && before !== normalized) {
                          toast.info(`Horário ajustado para a janela permitida (${GLOBAL_START}–${GLOBAL_END}).`);
                        }
                      }}
                    />
                  </Grid>

                  {/* ================================ */}
                  {/* PARTE 2: CONFIGURAÇÕES DE ENVIO */}
                  {/* ================================ */}
                  <Grid xs={12} item style={{ marginTop: 24 }}>
                    <Typography variant="h6" color="primary" style={{ marginBottom: 16, fontWeight: 'bold' }}>
                      📤 Configurações de Envio
                    </Typography>
                  </Grid>
                  
                  {/* 1. Chip de envio (WhatsApp) */}
                  <Grid xs={12} md={4} item>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel id="whatsapp-selection-label">
                        {i18n.t("campaigns.dialog.form.whatsapp")}
                      </InputLabel>
                      <Field
                        as={Select}
                        label={i18n.t("campaigns.dialog.form.whatsapp")}
                        placeholder={i18n.t("campaigns.dialog.form.whatsapp")}
                        labelId="whatsapp-selection-label"
                        id="whatsappIds"
                        name="whatsappIds"
                        required
                        error={touched.whatsappId && Boolean(errors.whatsappId)}
                        disabled={!campaignEditable}
                        value={whatsappId}
                        onChange={(event) => {
                          setWhatsappId(event.target.value)
                        }}
                      >
                        {whatsapps &&
                          whatsapps.map((whatsapp) => (
                            <MenuItem key={whatsapp.id} value={whatsapp.id}>
                              {whatsapp.name}
                            </MenuItem>
                          ))}
                      </Field>
                    </FormControl>
                  </Grid>

                  {/* 2. Abrir Ticket */}
                  <Grid xs={12} md={4} item>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel id="openTicket-selection-label">
                        {i18n.t("campaigns.dialog.form.openTicket")}
                      </InputLabel>
                      <Field
                        as={Select}
                        label={i18n.t("campaigns.dialog.form.openTicket")}
                        placeholder={i18n.t(
                          "campaigns.dialog.form.openTicket"
                        )}
                        labelId="openTicket-selection-label"
                        id="openTicket"
                        name="openTicket"
                        error={
                          touched.openTicket && Boolean(errors.openTicket)
                        }
                        disabled={!campaignEditable}
                      >
                        <MenuItem value={"enabled"}>{i18n.t("campaigns.dialog.form.enabledOpenTicket")}</MenuItem>
                        <MenuItem value={"disabled"}>{i18n.t("campaigns.dialog.form.disabledOpenTicket")}</MenuItem>
                      </Field>
                    </FormControl>
                  </Grid>

                  {/* 3. Status do Ticket */}
                  <Grid xs={12} md={4} item>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel id="confirmation-selection-label">
                        {i18n.t("campaigns.dialog.form.confirmation")}
                      </InputLabel>
                      <Field
                        as={Select}
                        label={i18n.t("campaigns.dialog.form.confirmation")}
                        placeholder={i18n.t(
                          "campaigns.dialog.form.confirmation"
                        )}
                        labelId="confirmation-selection-label"
                        id="confirmation"
                        name="confirmation"
                        error={
                          touched.confirmation && Boolean(errors.confirmation)
                        }
                        disabled={!campaignEditable}
                      >
                        <MenuItem value={false}>Desabilitada</MenuItem>
                        <MenuItem value={true}>Habilitada</MenuItem>
                      </Field>
                    </FormControl>
                  </Grid>

                  {/* 4. Fila */}
                  <Grid xs={12} md={4} item>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel id="queue-selection-label">
                        {i18n.t("campaigns.dialog.form.queue")}
                      </InputLabel>
                      <Select
                        labelId="queue-selection-label"
                        id="queueId"
                        value={selectedQueue}
                        label={i18n.t("campaigns.dialog.form.queue")}
                        onChange={(e) => setSelectedQueue(e.target.value)}
                        disabled={!campaignEditable || values.openTicket === 'disabled'}
                      >
                        <MenuItem value="">{i18n.t("campaigns.dialog.form.queueSelect")}</MenuItem>
                        {queues.map((queue) => (
                          <MenuItem key={queue.id} value={queue.id}>
                            {queue.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* 5. Usuário */}
                  <Grid xs={12} md={8} item>
                    <Autocomplete
                      style={{ marginTop: '8px' }}
                      variant="outlined"
                      margin="dense"
                      className={classes.formControl}
                      getOptionLabel={(option) => `${option.name}`}
                      value={selectedUser}
                      size="small"
                      onChange={(e, newValue) => {
                        setSelectedUser(newValue);
                        if (newValue != null && Array.isArray(newValue.queues)) {
                          if (newValue.queues.length === 1) {
                            setSelectedQueue(newValue.queues[0].id);
                          }
                          setQueues(newValue.queues);

                        } else {
                          setQueues(allQueues);
                          setSelectedQueue("");
                        }
                      }}
                      options={options}
                      filterOptions={filterOptions}
                      freeSolo
                      fullWidth
                      autoHighlight
                      disabled={!campaignEditable || values.openTicket === 'disabled'}
                      noOptionsText={i18n.t("transferTicketModal.noOptions")}
                      loading={loading}
                      renderOption={option => (<span> <UserStatusIcon user={option} /> {option.name}</span>)}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label={i18n.t("transferTicketModal.fieldLabel")}
                          variant="outlined"
                          onChange={(e) => setSearchParam(e.target.value)}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                {loading ? (
                                  <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                        />
                      )}
                    />
                  </Grid>

                  {/* ================================ */}
                  {/* PARTE 3: CONFIGURAÇÕES DE CONTATOS */}
                  {/* ================================ */}
                  <Grid xs={12} item style={{ marginTop: 24 }}>
                    <Typography variant="h6" color="primary" style={{ marginBottom: 16, fontWeight: 'bold' }}>
                      👥 Configurações de Contatos
                    </Typography>
                  </Grid>

                  {/* 1. Origem dos contatos */}
                  <Grid xs={12} md={4} item>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel id="contactSource-selection-label">
                        Origem dos Contatos
                      </InputLabel>
                      <Select
                        label="Origem dos Contatos"
                        labelId="contactSource-selection-label"
                        id="contactSource"
                        value={contactSource}
                        onChange={(e) => {
                          console.log('Mudando contactSource para:', e.target.value);
                          setContactSource(e.target.value);
                        }}
                        disabled={!campaignEditable}
                      >
                        <MenuItem value="contactList">Lista de Contatos Manual</MenuItem>
                        <MenuItem value="tag">Contatos por Tag</MenuItem>
                        <MenuItem value="groups">Todos os Grupos</MenuItem>
                        <MenuItem value="groupsByWhatsapp">Grupos por Conexão</MenuItem>
                        <MenuItem value="specificGroups">Selecionar Grupos Específicos</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* 2. Lista de Contato */}
                  <Grid xs={12} md={4} item>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel id="contactList-selection-label">
                        {i18n.t("campaigns.dialog.form.contactList")}
                      </InputLabel>
                      <Field
                        as={Select}
                        label={i18n.t("campaigns.dialog.form.contactList")}
                        placeholder={i18n.t(
                          "campaigns.dialog.form.contactList"
                        )}
                        labelId="contactList-selection-label"
                        id="contactListId"
                        name="contactListId"
                        error={
                          touched.contactListId && Boolean(errors.contactListId)
                        }
                        disabled={!campaignEditable}
                      >
                        <MenuItem value="">Nenhuma</MenuItem>
                        {contactLists &&
                          contactLists.map((contactList) => (
                            <MenuItem
                              key={contactList.id}
                              value={contactList.id}
                            >
                              {contactList.name}
                            </MenuItem>
                          ))}
                      </Field>
                    </FormControl>
                  </Grid>

                  {/* 3. Limite Diário */}
                  <Grid xs={12} md={4} item>
                    <TextField
                      label="Limite Diário de Envios"
                      name="dailyLimit"
                      type="number"
                      value={dailyLimit}
                      onChange={(e) => setDailyLimit(parseInt(e.target.value) || 250)}
                      error={dailyLimit < 1 || dailyLimit > 250}
                      helperText={
                        dailyLimit < 1 || dailyLimit > 250 
                          ? "Limite deve ser entre 1 e 250 mensagens por dia" 
                          : `Máximo ${dailyLimit} mensagens por dia`
                      }
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      disabled={!campaignEditable}
                      inputProps={{ min: 1, max: 250 }}
                    />
                  </Grid>

                  {/* CAMPOS CONDICIONAIS BASEADOS NA ORIGEM */}
                  
                  {/* CAMPO TAG - Só aparece se origem for "tag" */}
                  {contactSource === "tag" && (
                  <Grid xs={12} md={4} item>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel id="tagList-selection-label">
                        {i18n.t("campaigns.dialog.form.tagList")}
                      </InputLabel>
                      <Field
                        as={Select}
                        label={i18n.t("campaigns.dialog.form.tagList")}
                        placeholder={i18n.t("campaigns.dialog.form.tagList")}
                        labelId="tagList-selection-label"
                        id="tagListId"
                        name="tagListId"
                        error={touched.tagListId && Boolean(errors.tagListId)}
                        disabled={!campaignEditable}
                      >
                        {Array.isArray(tagLists) &&
                          tagLists.map((tagList) => (
                            <MenuItem key={tagList.id} value={tagList.id}>
                              {tagList.name}
                            </MenuItem>
                          ))}
                      </Field>
                    </FormControl>
                  </Grid>
                  )}

                  {/* CAMPO WHATSAPP - Só aparece se origem for "groupsByWhatsapp" */}
                  {contactSource === "groupsByWhatsapp" && (
                  <Grid xs={12} md={4} item>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel id="sourceWhatsapp-selection-label">
                        Conexão WhatsApp para Grupos
                      </InputLabel>
                      <Select
                        label="Conexão WhatsApp para Grupos"
                        labelId="sourceWhatsapp-selection-label"
                        id="sourceWhatsappId"
                        value={sourceWhatsappId}
                        onChange={(e) => setSourceWhatsappId(e.target.value)}
                        disabled={!campaignEditable}
                      >
                        {whatsapps
                          .filter(w => w.allowGroup)
                          .map(whatsapp => (
                            <MenuItem key={whatsapp.id} value={whatsapp.id}>
                              {whatsapp.name}
                            </MenuItem>
                          ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  )}

                  {/* CAMPO SELEÇÃO DE GRUPOS ESPECÍFICOS */}
                  {contactSource === "specificGroups" && (
                  <Grid xs={12} md={8} item>
                    <FormControl
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      className={classes.formControl}
                    >
                      <InputLabel id="availableGroups-selection-label">
                        Selecionar Grupos ({availableGroups.length} disponíveis)
                      </InputLabel>
                      <Select
                        label={`Selecionar Grupos (${availableGroups.length} disponíveis)`}
                        labelId="availableGroups-selection-label"
                        id="availableGroups"
                        multiple
                        value={selectedGroups}
                        onChange={(e) => setSelectedGroups(e.target.value)}
                        disabled={!campaignEditable}
                        renderValue={(selected) => (
                          <div>
                            {selected.length > 0 ? `${selected.length} grupos selecionados` : 'Nenhum grupo selecionado'}
                          </div>
                        )}
                      >
                        {availableGroups.map((group) => (
                          <MenuItem key={group.id} value={group.id}>
                            <Checkbox checked={selectedGroups.indexOf(group.id) > -1} />
                            <ListItemText 
                              primary={group.name} 
                              secondary={`WhatsApp: ${group.whatsapp?.name || 'N/A'}`}
                            />
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  )}

                  {/* ✅ JANELA DE ENVIO POR CAMPANHA */}
                  <Grid xs={12} item style={{ marginTop: 24 }}>
                    <Typography variant="h6" color="primary" style={{ marginBottom: 16, fontWeight: 'bold' }}>
                      ⏰ Janela de envio desta campanha
                    </Typography>
                    <Typography variant="body2" style={{ marginTop: -8, marginBottom: 8, color: '#666' }}>
                      Observação: O sistema respeita a política global de envios entre {GLOBAL_START} e {GLOBAL_END}.
                    </Typography>
                  </Grid>
                  <Grid xs={12} md={3} item>
                    <TextField
                      label="Início do envio (hora)"
                      type="time"
                      margin="dense"
                      variant="outlined"
                      fullWidth
                      value={sendWindow.startHour}
                      onChange={(e) => {
                        const cl = clampTime(e.target.value);
                        setSendWindow(prev => {
                          let start = cl;
                          let end = prev.endHour;
                          // garante start <= end
                          if (end && start && start > end) end = start;
                          return { ...prev, startHour: start, endHour: end };
                        });
                      }}
                      inputProps={{ step: 300, min: GLOBAL_START, max: GLOBAL_END }}
                      disabled={!campaignEditable}
                    />
                  </Grid>
                  <Grid xs={12} md={3} item>
                    <TextField
                      label="Término do envio (hora)"
                      type="time"
                      margin="dense"
                      variant="outlined"
                      fullWidth
                      value={sendWindow.endHour}
                      onChange={(e) => {
                        const cl = clampTime(e.target.value);
                        setSendWindow(prev => {
                          let start = prev.startHour;
                          let end = cl;
                          // garante start <= end
                          if (start && end && start > end) start = end;
                          return { ...prev, startHour: start, endHour: end };
                        });
                      }}
                      inputProps={{ step: 300, min: GLOBAL_START, max: GLOBAL_END }}
                      disabled={!campaignEditable}
                    />
                  </Grid>
                  <Grid xs={12} md={3} item>
                    <FormControlLabel
                      control={<Checkbox checked={sendWindow.sabado} onChange={(e) => setSendWindow(prev => ({ ...prev, sabado: e.target.checked }))} color="primary" />}
                      label="Permitir envios no sábado"
                    />
                  </Grid>
                  <Grid xs={12} md={3} item>
                    <FormControlLabel
                      control={<Checkbox checked={sendWindow.domingo} onChange={(e) => setSendWindow(prev => ({ ...prev, domingo: e.target.checked }))} color="primary" />}
                      label="Permitir envios no domingo"
                    />
                  </Grid>

                </Grid>
                </TabPanel>

                {/* ✅ TAB 2: MENSAGENS */}
                <TabPanel value={activeTab} index={1}>
                  <Grid xs={12} item>
                    <Tabs
                      value={messageTab}
                      indicatorColor="primary"
                      textColor="primary"
                      onChange={(e, v) => setMessageTab(v)}
                      variant="fullWidth"
                      centered
                      style={{
                        background: "#f2f2f2",
                        border: "1px solid #e6e6e6",
                        borderRadius: 2,
                      }}
                    >
                      <Tab label="Msg. 1" index={0} />
                      <Tab label="Msg. 2" index={1} />
                      <Tab label="Msg. 3" index={2} />
                      <Tab label="Msg. 4" index={3} />
                      <Tab label="Msg. 5" index={4} />
                    </Tabs>
                    <Box style={{ paddingTop: 20, border: "none" }}>
                      {messageTab === 0 && (
                        <>
                          {values.confirmation ? (
                            <Grid spacing={2} container>
                              <Grid xs={12} md={6} item>
                                <>
                                  {renderConfirmationMessageField(
                                    "confirmationMessage1"
                                  )}
                                </>
                              </Grid>
                              <Grid xs={12} md={6} item>
                                <>{renderMessageField("message1")}</>
                              </Grid>
                            </Grid>
                          ) : (
                            <>{renderMessageField("message1")}</>
                          )}
                        </>
                      )}
                      {messageTab === 1 && (
                        <>
                          {values.confirmation ? (
                            <Grid spacing={2} container>
                              <Grid xs={12} md={6} item>
                                <>
                                  {renderConfirmationMessageField(
                                    "confirmationMessage2"
                                  )}
                                </>
                              </Grid>
                              <Grid xs={12} md={6} item>
                                <>{renderMessageField("message2")}</>
                              </Grid>
                            </Grid>
                          ) : (
                            <>{renderMessageField("message2")}</>
                          )}
                        </>
                      )}
                      {messageTab === 2 && (
                        <>
                          {values.confirmation ? (
                            <Grid spacing={2} container>
                              <Grid xs={12} md={6} item>
                                <>
                                  {renderConfirmationMessageField(
                                    "confirmationMessage3"
                                  )}
                                </>
                              </Grid>
                              <Grid xs={12} md={6} item>
                                <>{renderMessageField("message3")}</>
                              </Grid>
                            </Grid>
                          ) : (
                            <>{renderMessageField("message3")}</>
                          )}
                        </>
                      )}
                      {messageTab === 3 && (
                        <>
                          {values.confirmation ? (
                            <Grid spacing={2} container>
                              <Grid xs={12} md={6} item>
                                <>
                                  {renderConfirmationMessageField(
                                    "confirmationMessage4"
                                  )}
                                </>
                              </Grid>
                              <Grid xs={12} md={6} item>
                                <>{renderMessageField("message4")}</>
                              </Grid>
                            </Grid>
                          ) : (
                            <>{renderMessageField("message4")}</>
                          )}
                        </>
                      )}
                      {messageTab === 4 && (
                        <>
                          {values.confirmation ? (
                            <Grid spacing={2} container>
                              <Grid xs={12} md={6} item>
                                <>
                                  {renderConfirmationMessageField(
                                    "confirmationMessage5"
                                  )}
                                </>
                              </Grid>
                              <Grid xs={12} md={6} item>
                                <>{renderMessageField("message5")}</>
                              </Grid>
                            </Grid>
                          ) : (
                            <>{renderMessageField("message5")}</>
                          )}
                        </>
                      )}
                    </Box>
                    {/* ✅ VARIÁVEIS DA EMPRESA (somente leitura aqui) */}
                    <Box style={{ marginTop: 24, padding: 16, border: '1px solid #e0e0e0', borderRadius: 8, background: '#fafafa' }}>
                      <Typography variant="h6" style={{ marginBottom: 4, fontWeight: 'bold' }}>
                        Variáveis da empresa
                      </Typography>
                      <Typography variant="body2" style={{ color: '#666', marginBottom: 12 }}>
                        Estas variáveis são definidas no botão VARIÁVEIS da página de Campanhas e valem para toda a empresa. Aqui você pode:
                        1) Inserir o placeholder no texto atual; 2) Importar as opções para esta campanha (para sobrescrever conforme necessário).
                      </Typography>
                      {Object.keys(companyTextVariables).length === 0 ? (
                        <Typography variant="body2" style={{ color: '#888' }}>
                          Nenhuma variável cadastrada na empresa.
                        </Typography>
                      ) : (
                        <Box>
                          {Object.entries(companyTextVariables).map(([k, opts]) => (
                            <Box key={`company-var-${k}`} style={{ marginBottom: 12 }}>
                              <Box style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>{`{${k}}`}</Typography>
                                <Button size="small" variant="outlined" onClick={() => insertPlaceholderIntoActiveMessage(`{${k}}`)}>
                                  Inserir no texto
                                </Button>
                                <Button size="small" color="primary" onClick={() => importCompanyVariableToCampaign(k)} disabled={!campaignEditable}>
                                  Importar para campanha
                                </Button>
                              </Box>
                              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginTop: 6 }}>
                                {Array.isArray(opts) && opts.map((opt) => (
                                  <Chip key={`company-${k}-${opt}`} label={opt} />
                                ))}
                              </div>
                            </Box>
                          ))}
                        </Box>
                      )}
                      <Typography variant="caption" style={{ display: 'block', marginTop: 8, color: '#555' }}>
                        Edição destas variáveis é feita no botão VARIÁVEIS da página de Campanhas.
                      </Typography>
                    </Box>

                    {/* ✅ VARIÁVEIS ALEATÓRIAS POR CAMPANHA (overrides) */}
                    <Box style={{ marginTop: 24, padding: 16, border: '1px dashed #90caf9', borderRadius: 8, background: '#f5fafe' }}>
                      <Typography variant="h6" style={{ color: '#1976d2', marginBottom: 4, fontWeight: 'bold' }}>
                        Variáveis desta campanha
                      </Typography>
                      <Typography variant="body2" style={{ color: '#555', marginBottom: 12 }}>
                        Dica: personalize sua mensagem com {"{nome}"}, {"{numero}"}, {"{email}"}. Você também pode sobrescrever variáveis da empresa abaixo (ex.: {"{saudacao}"}) ou usar aleatórias na hora: {"{saudacao:Olá|Oi|Hey}"}. Prioridade: inline &gt; desta campanha &gt; da empresa &gt; dados do contato.
                      </Typography>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={4}>
                          <TextField
                            label="Nome da variável"
                            value={varKey}
                            onChange={(e) => setVarKey(e.target.value)}
                            placeholder="ex.: saudacao"
                            variant="outlined"
                            fullWidth
                            size="small"
                            disabled={!campaignEditable}
                            helperText="Use letras/números, _ ou -, ex.: saudacao"
                          />
                        </Grid>
                        <Grid item xs={12} md={6}>
                          <TextField
                            label="Adicionar opção"
                            value={varOption}
                            onChange={(e) => setVarOption(e.target.value)}
                            placeholder="ex.: Olá"
                            variant="outlined"
                            fullWidth
                            size="small"
                            disabled={!campaignEditable}
                            onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); addVarOption(); } }}
                          />
                        </Grid>
                        <Grid item xs={12} md={2} style={{ display: 'flex', alignItems: 'center' }}>
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={addVarOption}
                            disabled={!campaignEditable}
                          >
                            Adicionar
                          </Button>
                        </Grid>
                      </Grid>
                      {/* Lista de variáveis e opções como chips */}
                      <Box style={{ marginTop: 12 }}>
                        {Object.keys(textVariables).length === 0 && (
                          <Typography variant="body2" style={{ color: '#666' }}>
                            Nenhuma variável definida. Ex.: crie "saudacao" e adicione opções como "Olá", "Oi", "Hey".
                          </Typography>
                        )}
                        {Object.entries(textVariables).map(([k, opts]) => (
                          <Box key={k} style={{ marginBottom: 12 }}>
                            <Box style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                              <Typography variant="subtitle1" style={{ fontWeight: 'bold' }}>{`{${k}}`}</Typography>
                              <Button size="small" color="secondary" onClick={() => removeVariable(k)} disabled={!campaignEditable}>Remover</Button>
                            </Box>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                              {Array.isArray(opts) && opts.map((opt) => (
                                <Chip key={`${k}-${opt}`} label={opt} onDelete={campaignEditable ? () => removeVarOption(k, opt) : undefined} />
                              ))}
                            </div>
                          </Box>
                        ))}
                      </Box>
                      <Typography variant="caption" style={{ display: 'block', marginTop: 8, color: '#555' }}>
                        Como usar (explicação simples):
                        1) Variáveis fixas já prontas: {`{nome}`}, {`{numero}`}, {`{email}`}
                        2) Crie suas próprias variáveis aqui (ex.: {`{saudacao}`}) e adicione opções. A cada envio, o sistema escolhe uma opção aleatória.
                        3) Você também pode escrever na hora: {`{saudacao:Olá|Oi|Hey}`}
                        Prioridade: inline (na hora) &gt; variáveis desta campanha &gt; variáveis da empresa &gt; dados do contato.
                      </Typography>
                    </Box>
                  </Grid>
                </TabPanel>
              </DialogContent>
              <DialogActions>
                {campaign.status === "CANCELADA" && (
                  <Button
                    color="primary"
                    onClick={() => restartCampaign()}
                    variant="outlined"
                  >
                    {i18n.t("campaigns.dialog.buttons.restart")}
                  </Button>
                )}
                {campaign.status === "EM_ANDAMENTO" && (
                  <Button
                    color="primary"
                    onClick={() => cancelCampaign()}
                    variant="outlined"
                  >
                    {i18n.t("campaigns.dialog.buttons.cancel")}
                  </Button>
                )}
                <Button
                  onClick={handleClose}
                  color="primary"
                  disabled={isSubmitting}
                  variant="outlined"
                >
                  {i18n.t("campaigns.dialog.buttons.close")}
                </Button>
                {(campaignEditable || campaign.status === "CANCELADA") && (
                  <Button
                    type="submit"
                    color="primary"
                    disabled={isSubmitting}
                    variant="contained"
                    className={classes.btnWrapper}
                  >
                    {campaignId
                      ? `${i18n.t("campaigns.dialog.buttons.edit")}`
                      : `${i18n.t("campaigns.dialog.buttons.add")}`}
                    {isSubmitting && (
                      <CircularProgress
                        size={24}
                        className={classes.buttonProgress}
                      />
                    )}
                  </Button>
                )}
              </DialogActions>
            </Form>
          )}
        </Formik>
      </Dialog>

      {/* ✅ DIALOG DE AVISO DE RISCOS */}
      <Dialog
        open={showWarningDialog}
        onClose={handleCancelWarning}
        maxWidth="md"
        fullWidth
        PaperProps={{
          style: {
            borderRadius: 12,
            padding: 8
          }
        }}
      >
        <DialogTitle style={{ textAlign: 'center', color: '#f44336', fontWeight: 'bold' }}>
          ⚠️ Importante: Política de Uso do WhatsApp
        </DialogTitle>
        
        <DialogContent dividers style={{ padding: 24, lineHeight: 1.6 }}>
          <Typography variant="body1" style={{ marginBottom: 16, fontWeight: 'bold', color: '#d32f2f' }}>
            ATENÇÃO: O envio de campanhas em massa pode resultar em bloqueio temporário ou permanente do seu número no WhatsApp.
          </Typography>
          
          <Typography variant="h6" style={{ marginTop: 20, marginBottom: 12, color: '#f44336' }}>
            RISCOS IDENTIFICADOS:
          </Typography>
          <Typography component="div" variant="body2" style={{ marginBottom: 16 }}>
            • Envio para números que não consentiram em receber mensagens<br/>
            • Alto volume de mensagens em pouco tempo<br/>
            • Mensagens idênticas para muitos contatos<br/>
            • Denúncias por spam pelos destinatários<br/>
            • Violação dos Termos de Uso do WhatsApp Business
          </Typography>

          <Typography variant="h6" style={{ marginTop: 20, marginBottom: 12, color: '#ff9800' }}>
            RECOMENDAÇÕES DE SEGURANÇA:
          </Typography>
          <Typography component="div" variant="body2" style={{ marginBottom: 16 }}>
            • Envie apenas para contatos que consentiram explicitamente<br/>
            • Mantenha intervalos adequados entre envios<br/>
            • Personalize as mensagens sempre que possível<br/>
            • Monitore a taxa de resposta e bloqueios<br/>
            • Respeite horários comerciais (8h às 18h)
          </Typography>

          <Typography variant="h6" style={{ marginTop: 20, marginBottom: 12, color: '#2196f3' }}>
            RESPONSABILIDADE:
          </Typography>
          <Typography component="div" variant="body2" style={{ marginBottom: 20 }}>
            Ao confirmar, você declara que:<br/>
            ✓ Possui autorização dos destinatários<br/>
            ✓ Está ciente dos riscos de bloqueio<br/>
            ✓ Assume total responsabilidade pelo uso<br/>
            ✓ Seguirá as boas práticas de envio
          </Typography>

          <Typography variant="body2" style={{ 
            padding: 16, 
            backgroundColor: '#fff3e0', 
            border: '1px solid #ffcc02', 
            borderRadius: 8,
            color: '#e65100',
            fontWeight: 'bold'
          }}>
            Esta ferramenta é fornecida para uso responsável. O sistema não se responsabiliza por bloqueios ou penalizações aplicadas pelo WhatsApp.
          </Typography>

          <FormControlLabel
            control={
              <Checkbox
                checked={acceptedRisks}
                onChange={(e) => setAcceptedRisks(e.target.checked)}
                color="primary"
              />
            }
            label={
              <Typography variant="body1" style={{ fontWeight: 'bold' }}>
                ☑️ Li, compreendi e aceito os riscos. Assumo total responsabilidade pelo envio desta campanha.
              </Typography>
            }
            style={{ marginTop: 20 }}
          />
        </DialogContent>

        <DialogActions style={{ padding: 16, justifyContent: 'space-between' }}>
          <Button
            onClick={handleCancelWarning}
            color="default"
            variant="outlined"
            size="large"
          >
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmSave}
            color="primary"
            variant="contained"
            size="large"
            disabled={!acceptedRisks}
            style={{
              backgroundColor: acceptedRisks ? '#4caf50' : '#ccc',
              color: acceptedRisks ? 'white' : '#666'
            }}
          >
            Confirmar e Salvar Campanha
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default CampaignModal;